// @ts-nocheck
// TypeScript is ignoring this file. If you are editing this file you must fix the type issues.

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FontWeight, Heading, LiliButton, LiliButtonType } from '@lili/lili-frontend-common';
import { BUTTONS_TEXTS } from '../../flows/emergencyBucketDashboard/constants';
import { formatAmount } from '../../helpers/currency.helper';
import { CURRENCY, FORMAT_TYPE } from '../../constants/general';

interface IProps {
  bucketBalance: string;
  bucketName: string;
  addButtonDisabled: boolean;
  withdrawButtonDisabled: boolean;
  addButtonPath: string;
  withdrawButtonPath: string;
}

const BucketBalance = ({
  bucketBalance,
  bucketName,
  addButtonDisabled,
  withdrawButtonDisabled,
  addButtonPath,
  withdrawButtonPath,
}: IProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className='overflow-hidden flex flex-col justify-between bg-bw00 rounded-[12px] p-[32px] pt-[56px] items-center w-full shadow-widgetCard border border-outline-primary-bw-03 min-h-[230px]'>
      <div className='flex flex-col justify-center items-center'>
        <Heading.H3 id={`${t(bucketName).replaceAll(' ', '')}Balance`} fontWeight={FontWeight.MEDIUM}>
          {formatAmount(bucketBalance, FORMAT_TYPE.FORMATTED, CURRENCY.USD.SYMBOL, false)}
        </Heading.H3>
        <Heading.H9 id={`${t(bucketName).replaceAll(' ', '')}Title`} className='text-text-main-secondary mt-[4px]'>
          {t(bucketName)}
        </Heading.H9>
      </div>
      <div className='flex gap-[8px] w-full mt-[40px] h-[44px]'>
        <LiliButton
          disabled={addButtonDisabled}
          id='navigateToAddMoney'
          onClick={() => {
            navigate(addButtonPath);
          }}
          className='w-full h-[2.575rem]'
          title={t(BUTTONS_TEXTS.ADD)}
          type={LiliButtonType.TERTIARY}
        />
        <LiliButton
          disabled={withdrawButtonDisabled}
          id='navigateToWithdrawMoney'
          onClick={() => {
            navigate(withdrawButtonPath);
          }}
          className='w-full h-[2.575rem]'
          title={t(BUTTONS_TEXTS.WITHDRAW)}
          type={LiliButtonType.TERTIARY}
        />
      </div>
    </div>
  );
};

export default BucketBalance;
